import styled from 'styled-components';
import { fonts } from 'styles';

export const Container = styled.main`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow-x: hidden;
`;

export const Content = styled.section`
  width: 100%;
  max-width: 664px;
  margin: 0 auto;
  padding: 124px 24px;

  @media screen and (max-width: 500px) {
    padding: 64px 24px;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBold};
  font-size: 78px;
  line-height: 78px;
  letter-spacing: -0.05rem;
  text-align: center;
  margin-bottom: 56px;
  color: #fff;

  @media screen and (max-width: 500px) {
    font-size: 36px;
    line-height: 40px;
  }
`;

export const Text = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 18px;
  line-height: 26px;
  text-align: center;

  p {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  span {
    display: block;
    font-family: ${fonts.BentonSansMedium};
    text-transform: uppercase;
    color: #ef9b3a;
    padding-top: 24px;
  }

  @media screen and (max-width: 500px) {
    font-size: 16px;
    line-height: 24px;
  }
`;
